var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({staticClass:"app-image",class:{
    avatar: _vm.avatar,
    contain: _vm.contain,
    cover: _vm.cover,
    square: _vm.square,
  },style:({
    width: _vm.width ? `${_vm.width}px` : undefined,
    height: _vm.height ? `${_vm.height}px` : undefined,
    'background-color': _vm.backgroundColor,
    border: _vm.border,
    'border-radius': _vm.borderRadius,
  }),attrs:{"loading":_vm.lazyLoading ? 'lazy' : undefined,"src":_vm.currentImage,"width":_vm.width,"height":_vm.height},on:{"error":_vm.onError}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }